import Vue from 'vue';
import Vuex from 'vuex';
Vue.use(Vuex)

const store = new Vuex.Store({
	state: {
		newEventForm: {},
		editEventForm:{},
		personal:'', // 个人信息
	},
	mutations: {
		//新建会议
		setNewEventForm(state, value) {
			for(var key in value){
				state.newEventForm[key] = value[key];
			}
		},
		//编辑会议
		setEditEventForm(state, value) {
			state.editEventForm = value;
		},
		//重置
		resetNewEventForm(state, value){
			state.newEventForm = {};
			state.editEventForm = {}
		},
		setPersonal(state,value){
			state.personal = value;
		},
	}
})
export default store


// WEBPACK FOOTER //
// ./src/store.js